import React from 'react';

const pains = [
  {
    title: 'Client details are buried in texts and notes',
    body: 'Contact history, updates, and job notes are spread across your phone and desktop.',
  },
  {
    title: 'Projects are tracked in disconnected tools',
    body: 'Quotes, receipts, files, and cost tracking live in separate places that never stay in sync.',
  },
  {
    title: 'Job costs are hard to control mid-project',
    body: 'Without one source of truth, materials and labor drift before you catch it.',
  },
  {
    title: 'Documents don’t look consistent',
    body: 'Rushed proposals and invoices make strong work look less professional to clients.',
  },
];

const PainSection = () => {
  return (
    <section className="border-y border-slate-800 bg-slate-950 py-20 text-white md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center md:mb-16">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-300/90">The cost of scattered operations</p>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-white md:text-4xl lg:text-[2.35rem]">
            Running jobs from disconnected tools costs time and money
          </h2>
          <div className="mx-auto mt-8 max-w-2xl space-y-3 rounded-2xl border border-white/10 bg-white/[0.06] px-5 py-5 text-left text-sm leading-relaxed text-slate-200 md:text-base">
            <p className="font-medium text-white">Most contractors lose momentum to chaos, not lack of skill.</p>
            <p>DevelloTech gives you one place for quotes, clients, projects, files, and costs so every job runs cleaner.</p>
          </div>
          <p className="mt-8 text-base text-slate-400 md:text-lg">
            This is the contractor operating system built for daily execution, not just isolated estimates.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
          {pains.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 md:p-8"
            >
              <h3 className="text-lg font-semibold text-white md:text-xl">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400 md:text-base">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainSection;
